// Shared route metadata consumed by both:
// 1) React page components (set document.title during SPA navigation)
// 2) scripts/prerender.js (bakes title/description/canonical/og into per-route HTML)
export const SITE_URL = "https://www.kakkanat.com";

export const ROUTES = {
  home: {
    path: "/",
    title: "Prasava Raksha & Postnatal Care in Shoranur, Palakkad | Kakkanat",
    description:
      "Ayurvedic Prasava Raksha and postnatal care in Shoranur, Palakkad. Three private villas, doctor-led, rooted in hospitality. WhatsApp +91 90616 22255.",
  },
  location: {
    path: "/postnatal-care-palakkad-thrissur",
    title:
      "Postnatal Care near Palakkad, Thrissur & Ottapalam · Kakkanat",
    description:
      "Doctor-led Ayurvedic postnatal care in a private villa at Shoranur, about an hour from Thrissur and Palakkad. Only 3 villas. WhatsApp +91 90616 22255.",
  },
  faq: {
    path: "/faq",
    title:
      "Prasava Raksha FAQ · C-section, Bystander, Baby Care · Kakkanat",
    description:
      "Answers to what mothers ask before booking Ayurvedic postnatal care at Kakkanat, Shoranur: C-section, bystander stay, baby care, food, booking.",
  },
  blog: {
    path: "/blog/what-is-prasava-raksha",
    title: "What is Prasava Raksha? A Guide to Kerala Postnatal Care",
    description:
      "What happens in traditional Kerala Prasava Raksha, why the first 42 days matter, and how to choose a postnatal care centre near you.",
  },
};

export const canonicalFor = (routePath) =>
  routePath === "/" ? SITE_URL : `${SITE_URL}${routePath}`;
